import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

function readPrefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia(QUERY).matches;
}

/**
 * §7.2/§19.4: `prefers-reduced-motion: reduce` wyłącza przesuwanie kamery z interpolacją,
 * animowane krawędzie i dekoracyjne przejścia. Globalna reguła CSS (`styles/app.css`) już zeruje
 * `animation-duration`/`transition-duration` wszędzie — ten hook istnieje DODATKOWO dla miejsc,
 * gdzie komponent musi podjąć decyzję w JS (np. czy w ogóle uruchomić animowane
 * przejście/interpolację), a nie tylko skrócić czas trwania istniejącej animacji CSS.
 */
export function usePrefersReducedMotion(): boolean {
  const [prefersReducedMotion, setPrefersReducedMotion] =
    useState<boolean>(readPrefersReducedMotion);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }
    const mediaQueryList = window.matchMedia(QUERY);
    const handleChange = (event: MediaQueryListEvent): void => {
      setPrefersReducedMotion(event.matches);
    };
    mediaQueryList.addEventListener('change', handleChange);
    return () => {
      mediaQueryList.removeEventListener('change', handleChange);
    };
  }, []);

  return prefersReducedMotion;
}
